import { headerHeight } from './menuHeight';

/**
 * * calculateInOut
 * calculate the progress of a section entering the viewport from 0 when elem top intersects the viewport bottom
 * towards 1 when elem covers viewport or viewport covers elem (based on which elem is largest), scrolling in downward
 * direction value will move towards 0 after full cover (value = 1)
 * @return {number} progress 0..1 overlap ratio for elem overlapping viewport, < 0 before elem overlaps viewport, < 0 after elem has scrolled passed viewport
 */
export function calculateVerticalOverlap(boundingClientRect) {
  const maxTop = Math.max(boundingClientRect.top, 0);
  const minBottom = Math.max(0, Math.min(boundingClientRect.bottom, window.innerHeight));
  const overlapArea = minBottom - maxTop;

  const overlapRootRatio = overlapArea / window.innerHeight;
  const overlapElemRatio = boundingClientRect.height ? overlapArea / boundingClientRect.height : 0;

  return Math.max(overlapRootRatio, overlapElemRatio);
}

/**
 * * calculateIn
 * calculate the progress of a section entering the viewport from 0 when elem top intersects the viewport bottom
 * towards 1 when elem covers viewport or viewport covers elem (based on which elem is largest), scrolling in downward
 * direction value will be > 1 after full cover (value = 1)
 * @return {number} progress 0..1 overlap ratio for elem overlapping viewport, < 0 before elem overlaps viewport, > 1 after elem has scrolled passed viewport
 */
export function calculateIn(boundingClientRect) {
  const maxTop = Math.max(boundingClientRect.top, 0);
  const minBottom = Math.max(0, Math.min(boundingClientRect.bottom, window.innerHeight));
  const overlapArea = minBottom - maxTop;

  const overlapRootRatio = overlapArea / window.innerHeight;
  const overlapElemRatio = boundingClientRect.height ? overlapArea / boundingClientRect.height : 0;

  if (boundingClientRect.top < 0) return 1;
  return Math.max(overlapRootRatio, overlapElemRatio);
}

/**
 * * calculateTopToBottomBottomToTop
 * calculates progress accross viewport
 * @return {number} progress 0 - 1 accross viewport, negative (< 0) before entering, 1 when bottom of elem intersects with top of viewport top, then > 1
 */
export function calculateTopToBottomBottomToTop(boundingClientRect) {
  const distanceToGo = boundingClientRect.height + window.innerHeight - headerHeight; // 👈 distance for elem to travel over viewport from not visible through fully visible back to not visible:
  const distanceWent = boundingClientRect.height + window.innerHeight - boundingClientRect.bottom; // 👈 distance traveled relative to viewport:

  return distanceWent / distanceToGo;
}

/**
 * * calculateTopToBottomBottomToBottom
 * calculates progress accross viewport for elements with equal height or taller than viewport height
 * @return {number} progress negative before entering, 0 - 1 accross viewport, 1 when bottom of elem bottom intersects with viewport bottom, then > 1
 */
export function calculateTopToBottomBottomToBottom(boundingClientRect) {
  const distanceWent = boundingClientRect.height + window.innerHeight - boundingClientRect.bottom; // 👈 distance traveled relative to viewport
  const distanceToGo = boundingClientRect.height; // 👈 distance for elem to travel over viewport from not visible through fully visible back to elem bottom aligned with viewport bottom
  return distanceWent / distanceToGo;
}
